module.exports = __webpack_public_path__ + "static/fe272868-e45d-46aa-bf91-c9c42bd5f509-e75786c812186a0c2107339a8b55f2a3.jpeg";